export default __webpack_public_path__ + "static/media/tokenlist.124f110b.svg";